import { render, staticRenderFns } from "./TimKiemChiSo.vue?vue&type=template&id=75c33843&"
import script from "./TimKiemChiSo.vue?vue&type=script&lang=js&"
export * from "./TimKiemChiSo.vue?vue&type=script&lang=js&"
import style0 from "./TimKiemChiSo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports